export const environment = {
    production: false,
    apiUrl: 'https://api.cdr.preprod-s4.cawita.com',
    assetUrl: 'https://assets.cdr.preprod-s4.cawita.com',
    customerSpaceUrl: 'https://share.cdr.preprod-s4.cawita.com',
    protectedAssetPath: 'private',
    publicAssetPath: 'public',
    recaptchaSiteKey: '6LfgUtoaAAAAAAxFBLNU6FcAhEboBvEl6G0ZBiuR'
};